<app-header></app-header>
    <div class="image-container">
        <img style="padding: 0; margin: 0;" src="assets/navimage.png" width="100%" alt="Your Image">
        <div class="image-text">
          <p>Curriculum CBSE</p>
        </div>
      </div>    
      <div class="bg-white" style="height: 10vh;"></div>

<div class="container-fluid behind">
    <div class=" row">
      <div class="col-lg-8 col-sm-12 p-4 mt-1"> 
        <div class="dir mt-2">
           Curriculum CBSE
           <div class="behbtm"></div>
        </div> 
        <div class="dir-p mt-5">
           <span class="mb-2">The curriculum refers to the lessons and educational content to be taught to a learner in a school. In empirical terms, it may be regarded as the sum total of a planned set of educational experiences provided to a learner by a school. It encompasses general objectives of learning, competencies to be attained, courses of study, subject-wise learning outcomes and content, pedagogical practices and assessment guidelines</span> 
           <div class="fle"><img src="assets/tick_curri.svg" alt=""> <span class="ms-3">You can have a list of students including their fathers' names and classes.</span> </div>
           <div class="fle"><img src="assets/tick_curri.svg" alt=""> <span class="ms-3">Emphasize constructivist rather than rote learning by highlighting the importance of hands-on experience.</span> </div>
           <div class="fle"><img src="assets/tick_curri.svg" alt=""> <span class="ms-3">Promote Critical and Creative Thinking aligned to the 21st Century Skills in classrooms.</span> </div>
        </div> 
      </div>
      <div class="col-lg-4 col-sm-12">
         <div class="text-center mt-5" >
          <img class="mt-5" style="width: 250px;" src="assets/curriculum.png" alt="">
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>